import React from "react";

export default function FirstName(props) {
  return (
    <>
      <div className="sp-field sp-block">
        <label htmlFor={props.label}>{props.label}</label>

        <input type="text" id={"FirstName"} name={"FirstName"} />
      </div>
    </>
  );
}
